import { onMounted, onUnmounted } from "vue";

export function useEvent(target, event, handler)
{
	onUnmounted(() => target.removeEventListener(event, handler));
	onMounted(() => target.addEventListener(event, handler));
}
